import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { BusinessCategoryAudit } from '../../+models/company-profile-audit.model';

@Component({
  selector: 'sd-portal-business-category-audit-list',
  templateUrl: './business-category-audit-list.component.html',
  styleUrls: ['./business-category-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BusinessCategoryAuditListComponent implements OnInit {
  @Input() businessCategoryId: number;
  @Input() loading: boolean;
  @Input() businessCategoryAudits: BusinessCategoryAudit[];

  @Output() loadBusinessCategory = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadBusinessCategory.emit(this.businessCategoryId);
  }

  onNextPage() {
    this.nextPage.emit(this.businessCategoryId);
  }
}
